import { Box, Button, FormControl, FormErrorMessage, FormLabel, Grid, GridItem, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, SimpleGrid, Spinner, Table, TableContainer, Tbody, Td, Thead, Tr, useDisclosure, useToast } from "@chakra-ui/react"
import { Row } from "@tanstack/react-table";
import { Field, Formik } from "formik";
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { MeterSetting, User } from "../../types";
import { useAddControllerMeterSettingMutation, useDeleteControllerMeterSettingMutation, useGetControllerMeterSettingsQuery, useGetUsersQuery, useUpdateControllerMeterSettingMutation } from "../api/api";
import { PaginatedTable } from "../table/table"
interface meterModel {
	value: string
	name: string
}
interface meterOption {
	name: string;
	models: Record<string, meterModel>
}

const meterOptions: Record<string, meterOption> = {
	'mbus': {
		name: 'M-Bus',
		models: {
			'garo-GNM3D-MBUS': {
				value: 'garo-GNM3D-MBUS',
				name: 'Garo GNM3D-MBUS elmätare',
			}
		},
		// idText: 'Mbus primärt ID'
	},
	'mqtt': {
		name: 'MQTT',
		models: {
			'p1ib': {
				value: 'p1ib',
				name: 'P1IB',
			}
		},
		// idText: 'Mbus primärt ID'
	},
	'modbus-tcp': {
		name: 'Modbus TCP',
		models: {
			'holdingreg-10scale-16bit': {
				value: 'holdingreg-10scale-16bit',
				name: 'Holding Register 10scale 16bit',
			}
		},
		// idText: 'Mbus primärt ID'
	}
}


const positions: Record<string, string> = {
	"heatpump_electric": 'Värmepumpen EL',
	'heatpump_heat': 'Värmepumpen Tillverkad energi',
	"districtHeating": 'Fjärrvärmen energi',
	"building": 'Samtlig EL på nätabbonemanget',
	"indoor_temp_min": 'Inomhustemperatur min',
	"indoor_temp_avg": 'Inomhustemperatur medel',
	"indoor_temp_max": 'Inomhustemperatur max',
}

export const MeterSettingsTable = () => {

	const { id } = useParams() as { id: string };
	const { data, error, isFetching } = useGetControllerMeterSettingsQuery(id, { refetchOnMountOrArgChange: true });
	// const { isOpen: isOpenAdd, onOpen: onOpenAdd, onClose: onCloseAdd } = useDisclosure();
	const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
	const [editingMeter, setEditingMeter] = useState<MeterSetting | undefined>();
	const toast = useToast();
	//TODO lägg till column med när vi senast hämtade data?
	const { current: cols } = useRef([
		{
			header: "Typ",
			accessorKey: "interfaceType",
			cell: (row: any) => meterOptions[row.getValue()].name,
			size: 50
		},
		{
			header: "Modell",
			accessorKey: "model",
			cell: (row: any): any => {
				return meterOptions[row.row.original.interfaceType].models[row.getValue()].name;
			},
		},
		{
			header: "Position",
			accessorKey: "position",
			cell: (row: any) => positions[row.getValue()],
		},
		{
			header: "Adress",
			accessorKey: "address"
		},
		{
			header: "ID",
			accessorKey: "primaryId"
		},
	]);

	if (isFetching) {
		return <Spinner size='xl' />;
	}


	const onRowClick = (row: Row<any>) => {
		setEditingMeter(row.original)
		onOpenEdit()
	}
	return (
		<>

			<Grid templateColumns='repeat(5, 1fr)' >
				<GridItem colSpan={3}>
					<Heading pb='20px' as='h1' size='md' >
						Mätare
					</Heading>
				</GridItem>
				<GridItem colSpan={1} />
				<GridItem colSpan={1} textAlign='right'>
					<Button
						onClick={() => {
							setEditingMeter({ controllerId: id, interfaceType: "", model: "", primaryId: "", position: "", address: "" })
							onOpenEdit()
						}}
						bg={'teal.400'}
						color={'white'}
						rounded={'lg'}
						_hover={{
							bg: 'teal.500',
						}}
						_focus={{
							bg: 'teal.500',
						}}>
						Lägg till
					</Button>
				</GridItem>
			</Grid>
			<TableContainer>
				<Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
					<ModalOverlay />
					<ModalContent minWidth="fit-content" height="fit-content">
						<ModalHeader>{editingMeter?.id ? "Ändra" : "Skapa"}</ModalHeader>
						<ModalCloseButton />
						<ModalBody>
							<ModalEditMeter onClose={onCloseEdit} meter={editingMeter} />
						</ModalBody>

						<ModalFooter>
						</ModalFooter>
					</ModalContent>
				</Modal>
				<PaginatedTable onRowHover={{
					bg: 'teal.400',
					color: 'white',
					cursor: 'pointer',
				}} onRowClick={onRowClick} __css={{ tableLayout: 'fixed', width: 'full' }} size='sm' columns={cols} data={data} />

			</TableContainer>
		</>
	)
}



interface ModalEditMeterProps {
	meter?: MeterSetting
	onClose?: () => void;
}



const meterTypeOptions = () => {
	return [<option value="">Välj:</option>, Object.keys(meterOptions).map((key) => {
		return <option value={key}>{meterOptions[key].name}</option>;
	})]
}
const meterModelOptions = (model: string) => {
	if (model === '') {
		return [];
	}
	return [<option value="">Välj:</option>, Object.entries(meterOptions[model].models).map((row) => {
		return <option value={row[0]}>{row[1].name}</option>;
	})]
}

export const ModalEditMeter = ({ meter, onClose }: ModalEditMeterProps) => {
	const [addMeterSetting, addResult] = useAddControllerMeterSettingMutation();
	const [deleteMeterSetting, deleteResult] = useDeleteControllerMeterSettingMutation();
	const [updateMeterSetting, updateResult] = useUpdateControllerMeterSettingMutation();
	const toast = useToast();

	if (!meter) {
		return null;
	}

	const deleteF = () => {
		deleteMeterSetting(meter);
		if (onClose) {
			onClose();
		}
	}

	return (
		<Formik
			initialValues={meter}
			onSubmit={(values) => {

				if (meter.id) {
					updateMeterSetting(values).unwrap().then((meter) => {
						toast({
							title: `Sparad!`,
							status: "success",
							isClosable: true,
						});
						if (onClose) {
							onClose();
						}

					});
					return;
				}
				addMeterSetting(values).unwrap().then(() => {
					toast({
						title: `Skapad!`,
						status: "success",
						isClosable: true,
					})
					if (onClose) {
						onClose();
					}
				});

			}}
		>
			{({ handleSubmit, errors, touched, values }) => (
				<form autoComplete="off" onSubmit={handleSubmit}>
					<FormControl isInvalid={!!errors.interfaceType && touched.interfaceType}>
						<FormLabel >Typ</FormLabel>
						<Field
							as={Select}
							id="interfaceType"
							name="interfaceType"
							validate={validateNotEmpty}
						>
							{meterTypeOptions()}
						</Field>
						<FormErrorMessage>{errors.interfaceType}</FormErrorMessage>
					</FormControl>
					<FormControl isInvalid={!!errors.model && touched.model}>
						<FormLabel >Modell</FormLabel>
						<Field
							as={Select}
							id="model"
							name="model"
							validate={validateNotEmpty}
						>
							{meterModelOptions(values.interfaceType)}
						</Field>
						<FormErrorMessage>{errors.model}</FormErrorMessage>
					</FormControl>
					<FormControl isInvalid={!!errors.position && touched.position}>
						<FormLabel >Vad mäter mätaren</FormLabel>
						<Field
							as={Select}
							id="position"
							name="position"
							validate={validateNotEmpty}
						>
							<option value="">Välj:</option>
							{Object.entries(positions).map((row) => <option value={row[0]}>{row[1]}</option>)}
						</Field>
						<FormErrorMessage>{errors.position}</FormErrorMessage>
					</FormControl>
					{values.interfaceType === 'modbus-tcp' && values.model === 'holdingreg-10scale-16bit' &&
						<FormControl isInvalid={!!errors.address && touched.address}>
							<FormLabel >Modbus address</FormLabel>
							<Field
								autoFocus={true}
								data-lpignore='true'
								as={Input}
								name="address"
								validate={validateNotEmpty}
							/>
							<FormErrorMessage>{errors.address}</FormErrorMessage>
						</FormControl>
					}
					<FormControl isInvalid={!!errors.primaryId && touched.primaryId}>
						<FormLabel >{values.interfaceType == "mbus" ? "Mbus primärt ID" : "ID"}</FormLabel>
						<Field
							autoFocus={true}
							data-lpignore='true'
							as={Input}
							name="primaryId"
							validate={validatePrimaryId}
						/>
						<FormErrorMessage>{errors.primaryId}</FormErrorMessage>
					</FormControl>



					<SimpleGrid minChildWidth='120px' spacing='5px'>
						{meter.id ? <Button mt={6} onClick={deleteF} colorScheme="red" width="200px">Ta bort</Button> : <div />}
						<Button mt={6} type="submit" colorScheme="teal" width="200px">Spara</Button>
					</SimpleGrid>
				</form>
			)}
		</Formik>

	)
}
const validateNotEmpty = (value: number | string) => {

	if (!value && value !== 0) {
		return "Måste fyllas i";
	}
}
const validatePrimaryId = (value: number | string) => {
	if (isNaN(Number(value))) {
		return "Måste vara ett nummer";
	}
	return validateNotEmpty(value)
}
